























































































































































































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import { FormField, FormStyles } from '@/types/Form.interface'
import Input, { ColorMode, InputType } from '@/types/Input.interface'
import FormStyleImage from '@/components/FormStyleImage.vue'
import { objectSet } from '@/utility/helpers'
export default Vue.extend({
    components: { FormStyleImage },
    props: {
        formStyles: {
            type: Object as PropType<FormStyles>,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // The different options for button shapes
            buttonShapes: [4, 10, 24],
            panelHeaderColor: '#FAFAFA'
        }
    },
    computed: {
        formBackgroundColorInput(): Input[] {
            return [
                {
                    type: InputType.COLORBTN,
                    name: 'BackgroundColor',
                    path: 'page.inner.background-color',
                    label: 'Background Color',
                    mode: ColorMode.hexa,
                    class: 'right',
                    validate: 'color',
                    cols: 12,
                    disabled: this.loading
                }
            ]
        },
        formButtonInputs(): Input[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'ButtonText',
                    label: 'Text',
                    validate: 'max:45',
                    path: 'form.button.value',
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    name: 'ButtonColor',
                    label: 'Button Color',
                    mode: ColorMode.hexa,
                    path: 'form.button.color',
                    validate: 'color',
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    name: 'ButtonTextColor',
                    label: 'Text Color',
                    mode: ColorMode.hexa,
                    path: 'form.button.text-color',
                    validate: 'color',
                    cols: 12,
                    disabled: this.loading
                }
            ]
        },
        formFieldsInputs(): FormField[] {
            return [
                {
                    type: InputType.CHECKBOX,
                    path: 'form.inputs.props.dark',
                    labelHTML: 'Dark',
                    labelStyle: `font-size:12px; line-height:6px; text-align:center; transform: rotate(${
                        this.$vuetify.breakpoint.smAndDown ? '-15deg' : '0deg'
                    })`,
                    cols: 4,
                    disabled: this.loading
                },
                {
                    type: InputType.CHECKBOX,
                    path: 'form.inputs.props.dense',
                    labelHTML: 'Dense',
                    labelStyle: `font-size: 12px; line-height: 6px; text-align: center; transform: rotate(${
                        this.$vuetify.breakpoint.smAndDown ? '-15deg' : '0deg'
                    })`,
                    cols: 4,
                    disabled: this.loading
                },
                {
                    type: InputType.CHECKBOX,
                    path: 'form.inputs.props.filled',
                    labelHTML: 'Filled',
                    labelStyle: `font-size: 12px; line-height: 6px; text-align: center; transform: rotate(${
                        this.$vuetify.breakpoint.smAndDown ? '-15deg' : '0deg'
                    })`,
                    cols: 4,
                    disabled: this.loading
                },
                {
                    type: InputType.CHECKBOX,
                    path: 'form.inputs.props.outlined',
                    labelHTML: 'Outlined',
                    labelStyle: `font-size: 12px; line-height: 6px; text-align: center; transform: rotate(${
                        this.$vuetify.breakpoint.smAndDown ? '-15deg' : '0deg'
                    })`,
                    cols: 4,
                    disabled: this.loading
                },
                {
                    type: InputType.CHECKBOX,
                    path: 'form.inputs.props.rounded',
                    labelHTML: 'Rounded',
                    labelStyle: `font-size:12px; line-height:6px; text-align:center; transform: rotate(${
                        this.$vuetify.breakpoint.smAndDown ? '-15deg' : '0deg'
                    })`,
                    cols: 4,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    path: 'form.inputs.props.background-color',
                    name: 'InputBackgroundColor',
                    label: 'Background Color',
                    mode: ColorMode.hexa,
                    validate: 'color',
                    cols: 12,
                    class: 'right',
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    path: 'form.inputs.props.color',
                    name: 'InputControlColor',
                    label: 'Control Color',
                    mode: ColorMode.hexa,
                    validate: 'color',
                    cols: 12,
                    class: 'right',
                    disabled: this.loading
                },
                {
                    type: InputType.SELECT,
                    path: 'form.inputs.columns',
                    name: 'Columns',
                    label: 'Columns (#)',
                    options: [1, 2, 3],
                    validate: 'numeric',
                    cols: 12,
                    colClass: 'mt-2',
                    disabled: this.loading
                }
            ]
        },
        formFieldsCompliance(): FormField[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'Privacy Policy',
                    label: "Privacy Policy",
                    path: 'privacyPolicy.message.value',
                    validate: 'url',
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.TEXT,
                    name: 'Terms Of Service',
                    label: "Terms Of Service",
                    path: 'termsOfService.message.value',
                    validate: 'url',
                    cols: 12,
                    disabled: this.loading
                },
            ]
        },
        formSuccessMessageInputs(): Input[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'SuccessMessageText',
                    label: InputType.TEXT,
                    path: 'success.message.value',
                    validate: 'max:300',
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.SLIDER,
                    name: 'MessageSize',
                    label: 'Size (px)',
                    path: 'success.message.size',
                    validate: 'numeric',
                    min: 0,
                    max: 64,
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.SLIDER,
                    name: 'MessageSpacing',
                    label: 'Spacing',
                    path: 'success.message.letter-spacing',
                    validate: 'numeric',
                    min: 0,
                    max: 12,
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    name: 'SuccessTitleColor',
                    path: 'success.message.color',
                    label: 'Text Color',
                    class: 'right',
                    mode: ColorMode.hexa,
                    validate: 'color',
                    cols: 12,
                    disabled: this.loading
                }
            ]
        },
        formSuccessTitleInputs(): Input[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'SuccessTitleText',
                    label: InputType.TEXT,
                    path: 'success.title.value',
                    validate: 'max:45',
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.SLIDER,
                    name: 'SuccessTitleSize',
                    label: 'Size (px)',
                    path: 'success.title.size',
                    validate: 'numeric',
                    min: 0,
                    max: 64,
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.SLIDER,
                    name: 'SuccessTitleSpacing',
                    label: 'Spacing',
                    path: 'success.title.letter-spacing',
                    validate: 'numeric',
                    min: 0,
                    max: 12,
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    name: 'SuccessTitleColor',
                    path: 'success.title.color',
                    label: 'Text Color',
                    class: 'right',
                    mode: ColorMode.hexa,
                    validate: 'color',
                    cols: 12,
                    disabled: this.loading
                }
            ]
        },
        formTitleInputs(): Input[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'TitleText',
                    label: 'Title',
                    path: 'form.title.value',
                    validate: 'max:45',
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.SLIDER,
                    name: 'TitleSize',
                    label: 'Size (px)',
                    path: 'form.title.size',
                    validate: 'numeric',
                    thumbLabel: true,
                    min: 4,
                    max: 64,
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.SLIDER,
                    name: 'TitleSpacing',
                    label: 'Spacing',
                    path: 'form.title.letter-spacing',
                    validate: 'numeric',
                    min: 0,
                    max: 12,
                    cols: 12,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    name: 'TitleColor',
                    path: 'form.title.color',
                    label: 'Text Color',
                    mode: ColorMode.hexa,
                    class: 'right',
                    validate: 'color',
                    cols: 12,
                    disabled: this.loading
                }
            ]
        },
        useDefaultFormImage(): boolean {
            if (!this.formStyles) return false

            //  We use the default form image if the user specifies they want to
            return this.formStyles.form.image.useDefault === false
        },
        useDefaultSuccessImage(): boolean {
            if (!this.formStyles) return false

            //  We use the default success image if the user specifies they want to
            return this.formStyles.success.image.useDefault === false
        }
    },
    methods: {
        updateModel(input: Input, val): void {
            //  Set our value
            objectSet(input.path, val, this.formStyles)

            //  We want to submit IF input type is NOT colorbtn, text, or slider
            const submit =
                input.type !== InputType.COLORBTN &&
                input.type !== InputType.TEXT &&
                input.type !== InputType.SLIDER

            //  If we are submitting, then tell the parent
            if (submit) this.$emit('submit', this.formStyles)
            else this.$emit('change')
        },
        changeButtonType(size: number): void {
            //  Update our button's border radius
            this.formStyles.form.button['border-radius'] = size

            //  Tell the parent to update
            this.$emit('submit', this.formStyles)
        },
        onBlur(input: Input, val): void {
            //  If no value is set, do nothing
            if (!val) return

            //  Else if a value is set, then just update our form based on the path
            objectSet(input.path, val, this.formStyles)

            //  Submit changes to parent
            this.$emit('submit', this.formStyles)
        },
        onPickerClosed(temp: object): void {
            //  Assign temp to our form styles
            Object.assign(this.formStyles, temp)

            //  Submit changes to parent
            this.$emit('submit', this.formStyles)
        },
        toggleDefaultFormImage(): void {
            //  Grab our useDefault val
            const useDef = this.formStyles.form.image.useDefault

            //  Set this to an object (it might not be any more)
            this.formStyles.form.image = {
                src: this.formStyles.form.image?.src,
                useDefault: !useDef
            }

            //  Submit changes to parent
            this.$emit('submit', this.formStyles)
        },
        toggleDefaultSuccessImage(): void {
            //  Grab our useDefault val
            const useDef = this.formStyles.success.image.useDefault

            //  Our value depends on useDef
            const val = useDef ? !useDef : false

            //  Set our value
            this.formStyles.success.image = {
                src: this.formStyles.success.image?.src,
                useDefault: val
            }

            //  Submit changes to parent
            this.$emit('submit', this.formStyles)
        },
        removeImage(type: string): void {
            //  Depending on our type, remove a different part of the form
            const pseudo = {
                background: () => (this.formStyles.page.inner['background-image'] = null),
                form: () => (this.formStyles.form.image.src = null),
                success: () => (this.formStyles.success.image.src = null)
            }

            //  Remove our image
            pseudo[type]()

            //  Tell the parent to update
            this.$emit('submit', this.formStyles)
        },
        setImage(type: string, link: string): void {
            //  Depending on our type, set a different part of the form
            const pseudo = {
                background: () => (this.formStyles.page.inner['background-image'] = link),
                form: () => (this.formStyles.form.image.src = link),
                success: () => (this.formStyles.success.image.src = link)
            }

            //  Set our image
            pseudo[type]()

            //  Tell the parent to update
            this.$emit('submit', this.formStyles)
        }
    },
    watch: {
        formStyles: {
            deep: true,
            handler() {
                //  Update all of our app forms
                for (const ref in this.$refs) {
                    //  Update temp
                    this.$refs[ref].temp = window._.cloneDeep(this.formStyles)
                }
            }
        }
    }
})
